// extracted by mini-css-extract-plugin
export default {"wrapper":"PageCardGrid_wrapper__h2cj9","grid":"PageCardGrid_grid__XIrUV"};